// @flow

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Header from '~/src/components/Header';
import EasyCustomization from './components/EasyCustomization';
import Footer from '~/src/components/Footer';

type Props = {
  easyCustomizationConfig: Object,
  setEasyCustomizationConfig: Function,
  setEasyCustomizationColors: Function,
  easyCustomizationWidgetParams: Object,
  setFormConfig: Function,
  isMobile?: boolean
}

@inject((stores: Object) => {
  const {
    easyCustomizationConfig,
    setEasyCustomizationConfig,
    setEasyCustomizationColors,
    easyCustomizationWidgetParams,
  } = stores.homeStore;
  const {
    isMobile,
    setFormConfig
  } = stores.editorStore;
  return {
    easyCustomizationConfig,
    setEasyCustomizationConfig,
    setEasyCustomizationColors,
    easyCustomizationWidgetParams,
    setFormConfig,
    isMobile,
  };
})

@observer
class HomePage extends Component<Props> {
  render() {
    return (
      <div className="container">
        <Header/>
        <EasyCustomization
          config={this.props.easyCustomizationConfig}
          setValue={(key, value) => {
            if (key === 'color') {
              this.props.setEasyCustomizationColors(value);
            }
            else {
              this.props.setEasyCustomizationConfig(key, value);
            }
          }}
          setFormConfig={this.props.setFormConfig}
          widgetParams={this.props.easyCustomizationWidgetParams}
          isMobile={this.props.isMobile}
        />
        <Footer/>
      </div>
    );
  }
}

export default HomePage;
